import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  PromoteBannerInterface,
  PromoteBannerResponseInterface,
} from 'src/app/configs/promoteBanner';
import { LanguageService } from 'src/app/services';
import { BannerService } from 'src/app/services/banner.service';
import { environment } from 'src/environments/environment.local';
import { Store } from '@ngrx/store';
import { selectProfileData } from 'app/store/me/me.selectors';

@Component({
  selector: 'app-promote-banner',
  templateUrl: './promote-banner.component.html',
  styleUrls: ['./promote-banner.component.scss'],
  standalone: true,
  imports: [],
})
export class PromoteBannerComponent implements OnDestroy, OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.formatImagePath(this.promoteBanner, event.target.innerWidth);
  }

  promoteBanner!: PromoteBannerInterface;
  dateNow: Date;
  isVisible: boolean = false;
  activeLanguage: string;
  imagePath: string;
  imageLink: string;
  subscriptions: Subscription[] = [];

  constructor(
    private languageService: LanguageService,
    private bannerService: BannerService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.subscriptions = [
      ...this.subscriptions,
      this.store.select(selectProfileData).subscribe(() => {
        this.bannerService
          .getBanner()
          .subscribe((banner: PromoteBannerResponseInterface) => {
            this.mapBanner(banner);
            this.setActivePromoteBanner();
          });
      }),
    ];
  }

  formatImagePath(promoteBanner: PromoteBannerInterface, innerWidth: number) {
    if (!promoteBanner) {
      return;
    }

    // Asset file by resolution
    if (innerWidth <= 900) {
      this.imagePath = promoteBanner.assetSm;
      // Mobile Mode
    } else if (innerWidth > 900 && innerWidth <= 1200) {
      this.imagePath = promoteBanner.assetMd;
      // Tablette Mode
    } else {
      // Desktop Mode
      this.imagePath = promoteBanner.assetLg;
    }

    // Asset Language exist ?
    const languageExist = promoteBanner.languages.find(
      (el) => el.lang === this.activeLanguage
    );

    this.activeLanguage = languageExist
      ? this.activeLanguage
      : promoteBanner.defaultLanguage;

    this.imageLink = promoteBanner.languages.find(
      (el) => el.lang === this.activeLanguage
    ).externalLink;

    this.imagePath = `${environment.api.banner.staticS3}${promoteBanner.project}/${this.imagePath}-${this.activeLanguage}.png`;
  }

  mapBanner(promoteBanner?: PromoteBannerResponseInterface) {
    if (!promoteBanner) {
      return;
    }

    return (this.promoteBanner = {
      name: promoteBanner.title,
      startDate: promoteBanner.start_date,
      endDate: promoteBanner.end_date,
      assetLg: 'banner_lg',
      assetMd: 'banner_md',
      assetSm: 'banner_sm',
      languages: [
        { lang: 'en', externalLink: promoteBanner.link_en },
        { lang: 'fr', externalLink: promoteBanner.link_fr },
        { lang: 'de', externalLink: promoteBanner.link_de },
      ],
      defaultLanguage: 'en',
      project: promoteBanner.project,
    });
  }

  navigateTo(link: string) {
    window.open(link, '_blank');
  }

  setActivePromoteBanner(): void {
    if (!this.promoteBanner) {
      return;
    }

    this.dateNow = new Date();

    this.isVisible = true;
    this.activeLanguage = this.languageService.format();

    this.formatImagePath(this.promoteBanner, window.innerWidth);

    this.subscriptions = [
      ...this.subscriptions,
      this.languageService.langEmitter.subscribe(() => {
        this.activeLanguage = this.languageService.format();
        this.formatImagePath(this.promoteBanner, window.innerWidth);
      }),
    ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
